module.exports = __webpack_public_path__ + "static/media/reports-nav-icon.a5f09764.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/reports-nav-icon.svg
// module id = 568
// module chunks = 0